import documentTranslations from "./documentTranslations";
import personTranslations from "./personTranslations";
import caseInsuranceTranslations from "./caseInsuranceTranslations";
import abstractCaseTranslations from "./abstractCaseTranslations";

const alimonyTranslations = {
  label: "Erstberatung Unterhalt",
  ...documentTranslations,
  ...abstractCaseTranslations,
  basicChoice: {
    label: "Typ der Analyse",
    values: {
      complete: "Komplette Berechnung",
      children: "Kindesunterhalt",
      other: "Keine Berechnung",
    },
  },
  advisoryAppointment: {
    label: "Beratungsgespräch",
  },
  alimonyPetitioner: {
    person: personTranslations,
    employmentStatus: {
      label: "Beschäftigungsstatus",
      values: {
        employed: "Angestellt",
        selfEmployed: "Selbstständig",
        unemployed: "Erwerbslos",
      },
    },
    netIncome: {
      label: "Nettoeinkommen",
    },
    otherIncome: {
      label: "Sonstiges Einkommen (Netto)",
    },
    hasMarriageRelatedDisadvantages: {
      label: "Ehebedingte Nachteile",
    },
    livingExpenses: {
      label: "Warmmiete",
    },
    monthlyMortgagePayment: {
      label: "Kreditrate (Immobilie)",
    },
    monthlyImputedRent: {
      label: "Wohnwert",
    },
    livingSituation: {
      label: "Wohnsituation",
      values: {
        tenant: "Zur Miete",
        ownerWithMortgage: "Immobilie in Finanzierung",
        ownerOutright: "Eigentumsimmobilie",
        other: "Weder Miete noch Eigentum",
      },
    },
    otherExpenses: {
      label: "Sonstige Ausgaben",
    },
  },
  alimonyPartner: {
    person: personTranslations,
    employmentStatus: {
      label: "Beschäftigungsstatus",
      values: {
        employed: "Angestellt",
        selfEmployed: "Selbstständig",
        unemployed: "Erwerbslos",
      },
    },
    netIncome: {
      label: "Nettoeinkommen",
    },
    otherIncome: {
      label: "Sonstiges Einkommen (Netto)",
    },
    hasMarriageRelatedDisadvantages: {
      label: "Ehebedingte Nachteile",
    },
    livingExpenses: {
      label: "Warmmiete",
    },
    monthlyMortgagePayment: {
      label: "Kreditrate (Immobilie)",
    },
    monthlyImputedRent: {
      label: "Wohnwert",
    },
    otherExpenses: {
      label: "Sonstige Ausgaben",
    },
    livingSituation: {
      label: "Wohnsituation",
      values: {
        tenant: "Zur Miete",
        ownerWithMortgage: "Immobilie in Finanzierung",
        ownerOutright: "Eigentumsimmobilie",
        other: "Weder Miete noch Eigentum",
      },
    },
  },
  caseInsurance: caseInsuranceTranslations,
  numberOfChildren: {
    label: "Anzahl Kinder",
  },
  dateMarriage: {
    label: "Heiratsdatum",
  },
  areSeparated: {
    label: "Getrennt",
  },
  dateSeparation: {
    label: "Trennungsdatum",
  },
  areDivorced: {
    label: "Geschieden",
  },
  dateDivorce: {
    label: "Scheidungsdatum",
  },
  children: {
    name: { label: "Name" },
    birthDate: { label: "Geburtsdatum" },
    childOf: {
      label: "Kind von",
      values: {
        petitioner: "Antragssteller",
        partner: "Partner",
        both: "Beiden",
      },
    },
    livesWith: {
      label: "Kind lebt bei",
      values: {
        petitioner: "Antragssteller",
        partner: "Partner",
        both: "Beiden",
        none: "Keinem",
      },
    },
    childAllowanceReceiver: {
      label: "Kindergeldempfänger",
      values: {
        petitioner: "Antragssteller",
        partner: "Partner",
        both: "Beide",
        child: "Das Kind",
        none: "Keiner",
      },
    },
  },
  residenceAddress: {
    streetAddress: {
      label: "Straße und Hausnummer",
    },
    postalCode: {
      label: "PLZ",
    },
    addressLocality: {
      label: "Ort",
    },
  },
};

export default alimonyTranslations;
